var exports = {
  "tB": "ApplicationDetail.module__page___N244M0",
  "Vr": "ApplicationDetail.module__pageHeader___N244M0",
  "d1": "ApplicationDetail.module__heroCard___N244M0",
  "CI": "ApplicationDetail.module__heroTop___N244M0",
  "ZY": "ApplicationDetail.module__heroTitle___N244M0",
  "Uz": "ApplicationDetail.module__metaInput___N244M0",
  "WA": "ApplicationDetail.module__detailGrid___N244M0",
  "fP": "ApplicationDetail.module__columnStack___N244M0",
  "E7": "ApplicationDetail.module__sectionSpacer___N244M0",
  "Nr": "ApplicationDetail.module__card___N244M0",
  "Wg": "ApplicationDetail.module__cardDanger___N244M0",
  "MY": "ApplicationDetail.module__cardHeader___N244M0",
  "JJ": "ApplicationDetail.module__cardTitle___N244M0",
  "Dc": "ApplicationDetail.module__cardSubtitle___N244M0",
  "eB": "ApplicationDetail.module__cardActions___N244M0",
  "zI": "ApplicationDetail.module__cardBody___N244M0",
  "tx": "ApplicationDetail.module__secretRow___N244M0",
  "cD": "ApplicationDetail.module__secretActions___N244M0",
  "PZ": "ApplicationDetail.module__fieldStack___N244M0",
  "rP": "ApplicationDetail.module__redirectList___N244M0",
  "bs": "ApplicationDetail.module__redirectRow___N244M0",
  "C2": "ApplicationDetail.module__redirectActions___N244M0",
  "py": "ApplicationDetail.module__redirectRemoveButton___N244M0",
  "t_": "ApplicationDetail.module__createRedirectButton___N244M0",
  "PM": "ApplicationDetail.module__scopeGrid___N244M0",
  "uH": "ApplicationDetail.module__fieldLabel___N244M0",
  "Jb": "ApplicationDetail.module__scopeList___N244M0",
  "LR": "ApplicationDetail.module__botPermissionList___N244M0",
  "_": "ApplicationDetail.module__scopeItem___N244M0",
  "$o": "ApplicationDetail.module__scopeLabel___N244M0",
  "Ud": "ApplicationDetail.module__avatarRow___N244M0",
  "_Q": "ApplicationDetail.module__avatarPreview___N244M0",
  "rZ": "ApplicationDetail.module__avatarPlaceholder___N244M0",
  "Jm": "ApplicationDetail.module__tagRow___N244M0",
  "bk": "ApplicationDetail.module__botUsernameSuffix___N244M0",
  "BK": "ApplicationDetail.module__helpText___N244M0",
  "jY": "ApplicationDetail.module__validationBox___N244M0",
  "JE": "ApplicationDetail.module__bannerRow___N244M0",
  "HF": "ApplicationDetail.module__builderResult___N244M0",
  "Ml": "ApplicationDetail.module__loadingState___N244M0",
  "cy": "ApplicationDetail.module__helperText___N244M0",
  "RJ": "ApplicationDetail.module__dangerContent___N244M0",
  "n7": "ApplicationDetail.module__dangerActions___N244M0",
  "z3": "ApplicationDetail.module__error___N244M0",
  "sM": "ApplicationDetail.module__srOnly___N244M0",
};

module.exports = exports;
